<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
            <el-row>
                <el-col span="8">
                    <el-form-item label="企业名称" prop="caName">
                        <el-input v-model="dataForm.caName" placeholder="企业名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col span="8">
                    <el-form-item label="社会信用代码" prop="taxCode">
                        <el-input v-model="dataForm.taxCode" placeholder="社会信用代码"></el-input>
                    </el-form-item>
                </el-col>
                <el-col span="8">
                    <el-form-item label="开户行" prop="bankName">
                        <el-input v-model="dataForm.bankName" placeholder="开户行"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col span="8">
                    <el-form-item label="开户账号" prop="bankAccount">
                        <el-input v-model="dataForm.bankAccount" placeholder="开户账号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col span="8">
                    <el-form-item label="注册地址" prop="address">
                        <el-input v-model="dataForm.address" placeholder="注册地址"></el-input>
                    </el-form-item>
                </el-col>
                <el-col span="8">
                    <el-form-item label="注册电话" prop="phone">
                        <el-input v-model="dataForm.phone" placeholder="注册电话"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col span="8">
                    <el-input v-model="dataForm.contacts" placeholder="联系人"></el-input>
                </el-col>
                <el-col span="8">
                    <el-input v-model="dataForm.contacts" placeholder="联系人"></el-input>
                </el-col>
                <el-col span="8">
                    <el-input v-model="dataForm.contacts" placeholder="联系人"></el-input>
                </el-col>
            </el-row>
            <el-form-item label="联系人" prop="contacts">
                <el-input v-model="dataForm.contacts" placeholder="联系人"></el-input>
            </el-form-item>

            <!-- <el-form-item label="营业执照路径" prop="licensePath">
                 <el-input v-model="dataForm.licensePath" placeholder="营业执照路径"></el-input>
             </el-form-item>
             <el-form-item label="身份证正面路径" prop="idcardFacePath">
                 <el-input v-model="dataForm.idcardFacePath" placeholder="身份证正面路径"></el-input>
             </el-form-item>
             <el-form-item label="身份证正面路径" prop="idcardBackPath">
                 <el-input v-model="dataForm.idcardBackPath" placeholder="身份证正面路径"></el-input>
             </el-form-item>-->
            <el-form-item label="启用" prop="isEnable">
                <!--  <el-input v-model="dataForm.isEnable" placeholder="是否启用 0禁用 1启用"></el-input>-->
                <el-radio-group v-model="dataForm.isEnable">
                    <el-radio :label="0">禁用</el-radio>
                    <el-radio :label="1">启用</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        caName: '',
        taxCode: '',
        bankName: '',
        bankAccount: '',
        address: '',
        contacts: '',
        phone: '',
        licensePath: '',
        idcardFacePath: '',
        idcardBackPath: '',
        isEnable: 1,
        status: '',
        userId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        caName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/info/ca/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/info/ca/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
